import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
body {
    font-family: 'Space Grotesk', sans-serif;
    width: 100%;
    display: block;
    margin: 0 auto;
    }
`;